// -----------------------------------------------------
// This file is generated by a script. DO NOT CHANGE IT!
// -----------------------------------------------------
import Nullstack from "nullstack";

class Icon extends Nullstack {

  static hash = '0399913368f0cf3ba6b6effe7361c38f';

  render({width, height, length, title, rotation, animation, speed, class: klass, color = "currentColor"}) {
    const transform = rotation ? `rotate(${rotation})` : false;
    const duration = {slow: "1.5s", fast: "0.5s"}[speed] || "1.0s";
    return (
      <svg width={width} height={height} transform={transform} class={klass} viewBox="0 0 512 512">
        {title && <title>{title}</title>}
        {animation === "spin" && <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="360 0 0" to="0 0 0" dur={duration} additive="sum" repeatCount="indefinite" />}
        <path d="M335.1385,256,495.697,95.4415a21.52,21.52,0,0,0,0-30.4336L446.9921,16.303a21.52,21.52,0,0,0-30.4336,0L256,176.8615,95.4415,16.303a21.52,21.52,0,0,0-30.4336,0L16.303,65.0079a21.52,21.52,0,0,0,0,30.4336L176.8615,256,16.303,416.5585a21.52,21.52,0,0,0,0,30.4336L65.0079,495.697a21.52,21.52,0,0,0,30.4336,0L256,335.1385,416.5585,495.697a21.52,21.52,0,0,0,30.4336,0l48.7049-48.7049a21.52,21.52,0,0,0,0-30.4336Z" transform="translate(0 0)" fill="none" stroke={color} stroke-linecap="round" stroke-linejoin="round" stroke-width={length || 20}/>
      </svg>
    )
  }

}

export default Icon;
if (module.hot) { module.hot.accept(); Nullstack.updateInstancesPrototypes(Icon, Icon.hash, 'd41d8cd98f00b204e9800998ecf8427e') }